export type ViewType = "day" | "multi-day" | "week" | "month";

// Desktop view mappings - full time grid views. Desktop doesn't expose
// `multi-day` in its picker, but a value can still arrive from persisted
// localStorage or a `?view=multi-day` link — fall back to single-day rather
// than crash on an unmapped key.
export const VIEW_TYPE_TO_FULLCALENDAR: Record<ViewType, string> = {
  day: "timeGridDay",
  "multi-day": "timeGridDay",
  week: "timeGridWeek",
  month: "dayGridMonth",
};

// Mobile view mappings — share the compact time-grid treatment with the
// desktop day sidebar instead of falling back to a list view for the week.
// `day` is the iOS-style single-day view (default on mobile). `multi-day`
// is the side-by-side two-day grid kept from the earlier 2-day-only design;
// the FullCalendar view `timeGrid2Day` is registered in CalendarView's
// CAROUSEL_VIEW_CONFIG.
export const VIEW_TYPE_TO_FULLCALENDAR_MOBILE: Record<ViewType, string> = {
  day: "timeGridDay",
  "multi-day": "timeGrid2Day",
  week: "timeGridWeek",
  month: "dayGridMonth",
};
